<template>
	<div class="pagenotfound">
		<div>
			<div>
				<h1>The page you requested is not available!</h1>
				<router-link class="button-type-i" to="/">Home</router-link>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{}
		},
		mounted(){
			relativeTo('nav', this.$el);
			this.$el.style.height = 'calc(100% - ' + id('nav').offsetHeight + 'px)';
		}
	}
</script>


// WEBPACK FOOTER //
// PageNotFound.vue?79942682